// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { BookOpen } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconBookOpen(props: any) {
    return <IconBase icon={BookOpen} {...props} />
  }

  export default IconBookOpen
  